import { render } from "./EntitlementBulkUpdateModal.vue?vue&type=template&id=b98ab936&scoped=true"
import script from "./EntitlementBulkUpdateModal.vue?vue&type=script&lang=js"
export * from "./EntitlementBulkUpdateModal.vue?vue&type=script&lang=js"

import "./EntitlementBulkUpdateModal.vue?vue&type=style&index=0&id=b98ab936&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b98ab936"]])

export default __exports__